import PropTypes from 'prop-types';

export default {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  item_number: PropTypes.string,
  vendor: PropTypes.string,
  model_number: PropTypes.string,
  item_name: PropTypes.string,
  stock: PropTypes.string,
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  status: PropTypes.string,
  note: PropTypes.string,
  errors: PropTypes.shape({
    item_number: PropTypes.array,
    model_number: PropTypes.array,
    item_name: PropTypes.array,
    stock: PropTypes.array,
    quantity: PropTypes.array,
    status: PropTypes.array,
    note: PropTypes.array,
  }),
};



// WEBPACK FOOTER //
// ./client/app/shared/types/phaseMerchandiseItem.js